type SettingsValue = boolean | string | number

export const useSettingsStore = defineStore('settings', () => {
  const settings = {
    debug: ref(useRuntimeConfig().public.debug),
    tracking: ref(false),
    renderEditorLinks: ref(false),

    autosuggestThreshold: ref(2),
    autosuggestSearchtype: ref('search_as_you_type'),
    autosuggestSize: ref(20),
    autosuggestSource: ref('focus'),

    mapZoomMax: ref(30),
    mapBoundsPadding: ref(40),
    mapAdditionalBucketZoom: ref(0),
    mapDeClustering: ref('accosum'),
    mapDeClusteringZoom: ref(12),
    mapDeClusteringCount: ref(20),
    mapShowBounds: ref(false),
    mapShowProposal: ref(false),
    mapShowMapInfo: ref(false),
    /**
     * The zoom level at which prices are displayed instead of clusters.
     */
    mapPricesZoomLevel: ref(13),
  }

  function set(name: string, value: SettingsValue) {
    ;(settings as Record<string, Ref>)[name].value =
      tryParseInt(value.toString()) ?? value
  }

  return { ...settings, all: settings, set }
})
